$('.ts-handle-event-type-change').on('change', function () {
    var typeOfEvent = $('#calenderTypeOfEvent option:selected').val().toString().toLowerCase();
    if (typeOfEvent === 'renovering') {
        $('#maintenanceForm').addClass('hidden');
        $('#renovationForm').removeClass('hidden');
    }
    if (typeOfEvent === 'åtgärd') {
        $('#maintenanceForm').removeClass('hidden');
        $('#renovationForm').addClass('hidden');
    }
});
$('.ts-handle-renovation-change').on('change', function () {
    var selectedRenovation = $('#availableRenovations option:selected');
    $('#renovationTypeId').val(selectedRenovation.data('typeid'));
    $('#hirelink').attr('href', selectedRenovation.data('hirelink'));
});
